import { tailwindBreakpoints } from "@hooks/useMediaQuery"

// Reuses useMediaQuery, which reads the breakpoint on the first render so phones don't flash the desktop sidebar
export function useIsMobile() {
  return !tailwindBreakpoints.md()
}
